<template>
    <div>
        <div class="pt-3">
            <search @condition="condition" :fields="searchFields">
                <!--                <el-button @click="addUser" v-access="{url:baseUrl,method:'POST'}" size="medium" slot="add"-->
                <!--                           icon="el-icon-plus" type="primary">添加-->
                <!--                </el-button>-->
            </search>
        </div>
        <div class="mt-3 my-order-table">
            <my-table :data="tableData" :fields="showFields">
                <template v-slot:invoice="data">
                    <el-link v-access="{url:addInvoiceUrl,method:'POST'}" @click="handleInvoice(data)"
                             type="primary">{{ getInvoiceText(data) }}
                    </el-link>
                </template>
                <template v-slot:auth_type="data">
                    {{ getAuthTypeText(data) }}
                    <el-tooltip v-if="data.all.auth_error" effect="dark" :content="data.all.auth_error" placement="top">
                        <span class="auth-error">
                            <i class="el-icon-warning-outline"></i>
                        </span>
                    </el-tooltip>
                </template>
                <template v-slot:tmp_download="data">
                    <div style="display: flex;justify-content: space-around">
                    <span @click="handleCommand('price',data.all)" class="tmp_download-link">
                        报价单
                    </span>
                        <span @click="handleCommand('request',data.all)" class="tmp_download-link">
                        请款单
                    </span>
                        <span @click="handleCommand('deal',data.all)" class="tmp_download-link">
                        购买合同
                    </span>
                    </div>
                </template>
                <template v-slot:pay_status="data">
                    <div>
                        <el-button @click="payOrder(data.all)" type="primary" size="mini" v-if="checkCanPay(data)">
                            付款
                        </el-button>
                        <el-tag v-else :type="formatDictKey('pro_pay_status',data.data,'tag')">
                            {{ formatDictKey('pro_pay_status', data.data, 'text') }}
                        </el-tag>
                    </div>
                </template>
                <el-table-column slot="operation" fixed="right" width="80" label="操作">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: space-between">
                            <el-tooltip
                                v-if="scope.row.pay_status===0&&scope.row.handle_status===4&&scope.row.order_from==='web'"
                                class="item" effect="dark" content="删除该笔订单" placement="top">
                                <el-button
                                    size="mini"
                                    type="danger"
                                    @click="cancelOrder(scope.$index,scope.row.order_id)"
                                    v-access="{url:baseCancelUrl,method:'POST'}"
                                    icon="el-icon-remove"></el-button>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <div class="pb-3 mt-3">
            <el-pagination
                @size-change="sizeChange"
                @current-change="pageChange"
                :current-page="page.pageNumber"
                :page-sizes="[10, 15, 30, 50]"
                :page-size="page.pageSize"
                :background="true"
                layout="sizes,prev, pager,next,total"
                :total="page.total">
            </el-pagination>
        </div>
        <form-dialog @closeFormDialog="submit" :title="form.title" :show="form.show" :fields="form.fields"
                     :rules="form.rules" :data="form.data"></form-dialog>
    </div>
</template>
<script>
import F from '@/fields/fields';
import search from "@/components/common/search";
import MyTable from "@/components/common/my-table";

export default {
    name: "appSms",
    components: {
        search, MyTable
    },
    created() {
        this.$store.dispatch('getDict', ['pro_product']);
    },
    mounted() {

    },
    data: function () {
        return {
            orderType: {
                list: [{title: 'Pro订单', value: 1}, {title: '手机APP订单', value: 2}],
                value: 1,
            },
            baseUrl: '/bbs/pay/list',
            baseInvoiceUrl: '/bbs/pay/piao',
            addInvoiceUrl: '/bbs/invoice/apiao',
            baseCancelUrl: '/bbs/pay/clio',
            page: {
                search: {},
                sort: {},
                total: 1,
                pageSize: 15,
                pageNumber: 1,
            },
            tableData: [],
            form: {
                action_name: '',
                show: false,
                title: '',
                data: {},
                fields: [],
                rules: {},
            }
        }
    },
    computed: {
        searchFields: function () {
            return F.search('proPayList', 'search');
        },
        showFields: function () {
            return F.show('proPayList', 'show');
        },
    },
    methods: {
        condition: function (search) {
            this.page.search = search;
            this.page.pageNumber = 1;
            this.search();
        },
        checkCanPay(info) {
            return false;
            if (info.data === 0 && info.all.pay_price > 200 && (info.all.auth_type === 2)) {
                //首先需要是未付款，并且价格大于2000，并且是购买的全能版或者是网络版新购买才可以，其它的都不行
                return true;
            }
            return false;
        },
        handleCommand(type, all) {
            let base = 'https://pro.bigemap.com/wk/l/d?';
            //先把发票内容请求下来
            this.$bbs.get('/bbs/invoice/piao', {
                params: {
                    id: all.invoice_id
                }
            }).then(data => {
                let id = data.data;
                let d = all;
                let pa = ['year=' + d.year, 'net_sum=' + d.net_sum, 'username=' + this.$store.state.userData.username, 'show_price=' + d.show_price, 'pay_price=' + d.pay_price,
                    'auth_type=' + d.auth_type,
                    'mask=' + d.random_mask,
                    'header=' + decodeURIComponent(id.header),
                    'address=' + decodeURIComponent(id.address || ''),
                    'buy_type=' + d.buy_type,
                    'invoice_type=' + id.invoice_type,
                    'type=' + type,
                ];
                pa = base + pa.join('&');
                let link = document.createElement('a');
                link.target = '_blank';
                link.href = pa;
                link.click();
                // console.log(pa);
            })

            // return {
            //     price:base+'/wk/l/d?type=price&'+pa,
            //     request:base+'/wk/l/d?type=request&'+pa,
            //     deal:base+'/wk/l/d?type=deal&'+pa,
            // };
        },
        search: function () {
            this.$bbs.get(this.baseUrl, {
                params: this.page,
            }).then(data => {
                this.page.total = data.data.total;
                this.page.pageNumber = data.data.pageNumber;
                this.page.pageSize = data.data.pageSize;
                this.tableData = data.data.data;
            });
        },
        formatDictKey(dict_key, value, type) {
            let dict = this.$store.state.dict[dict_key] || [];
            for (let i = 0; i < dict.length; i++) {
                if (dict[i]['value'] === value) {
                    if (type === 'tag') {
                        return dict[i]['type'];
                    } else {
                        return dict[i]['label'];
                    }
                }
            }
        },
        payOrder(order) {
            this.$emit('buy', {order, type: 'pc-pro'});
        },
        sortChange: function (column) {
            if (!column.order) return;
            this.page.sort = {prop: column.prop, order: column.order};
            this.search();
        },
        sizeChange: function (size) {
            this.page.pageSize = size;
            this.search();
        },
        pageChange: function (page) {
            this.page.pageNumber = page;
            this.search();
        },
        filterPlatform(value, row) {
            return row.tag === value;
        },
        handleInvoice(data) {
            if (data.data) {
                //如果有发票ID
                // let a=document.createElement('a');
                // a.target='_blank';
                // a.href=data.all.invoice_download_link;
                // a.click();
                this.$router.push({
                    name: 'pro_invoice',
                    params: {
                        id: data.data
                    }
                });
                // return;
            } else {
                //跳转到后台
                this.$router.push({
                    path: '/user/buy/addInvoice',
                    query: {
                        order_id: data.all.order_id,
                    }
                });
            }
            //先向服务器请求这个用户有多少的发票抬头
            // this.$bbs.get(this.addInvoiceUrl, {
            //     params: {
            //         order_id: data.all.order_id,
            //     },
            //     need: {
            //         error: true
            //     }
            // }).then(result => {
            //     if (!result.data.invoice_header.length) {
            //         this.$message.warning('请先前往权益中心->发票抬头 添加发票抬头信息');
            //         return;
            //     }
            //     this.$store.commit('updateDict', {pro_invoice_header: result.data.invoice_header});
            //     //弹出开票的窗口
            //     let form = F.get('proInvoiceList', 'add_invoice', {
            //         order_id: data.all.order_id,
            //         price: data.all.pay_price
            //     });
            //     this.actionName = 'addInvoice';
            //     this.form = form;
            //     this.index = data.index;
            // });
        },
        getInvoiceText(data) {
            switch (data.all.invoice_status) {
                case 2:
                    return '已开票';
                case 4:
                    return '等待开票';
                case 5:
                    return '订单关闭';
                case 1:
                    return '等待开票';
                default:
                    return '未填写开票信息';
            }
        },
        getAuthTypeText(data) {
            if (data.all._product_name) {
                //如果有服务器返回的名称
                return data.all._product_name;
            }
            let year = data.all.year ? data.all.year + '年' : "";
            let month = data.all.month ? data.all.month + '月' : '';
            let day = data.all.day ? data.all.day + '天' : '';
            let time_text = [year, month, day].join('');
            switch (data.all.auth_type) {
                case 2:
                    return '订阅版(' + time_text + ')'
                    break;
                case 3:
                    return '网络版(' + time_text + ')'
                    break;
                default:
                    return '未知';
            }
        },
        submit: function (data) {
            if (data.type === 'cancel') {
                this.form.show = false;
                return;
            }

            switch (this.actionName) {
                case 'addInvoice':
                    this.$bbs.post(this.addInvoiceUrl, data.data).then(adData => {
                        this.$message.success('申请成功!');
                        this.tableData.splice(this.index, 1, adData.data);
                        this.form.show = false;
                    });
                    break;
                case 'editFree':
                    this.$bbs.put(this.baseUrl, data.data).then(adData => {
                        this.$message.success('保存成功!');
                        this.tableData.splice(this.index, 1, adData.data);
                        this.form.show = false;
                    });
                    break;
                case 'addFree':
                    this.$bbs.post(this.baseUrl, data.data).then(userData => {
                        this.page.total++;
                        this.form.show = false;
                        this.$message.success('添加成功!');
                        this.tableData.unshift(userData.data);
                    });
                    break;
            }
        },
        editAd: function (index) {
            let form = F.get('freeGis', 'edit', this.tableData[index]);
            this.actionName = 'editFree';
            this.form = form;
            this.index = index;
        },
        addUser: function () {
            let form = F.get('freeGis', 'add');
            this.actionName = 'addFree';
            this.form = form;
        },
        authUser(index, userData) {
            this.$bbs.put(this.baseUrl, {action: 'confirm', free_id: userData.free_id}).then(adData => {
                this.$message.success('赠送成功!');
                this.tableData.splice(this.index, 1, adData.data);
            });
        },
        cancelOrder: function (index, order_id) {
            this.$confirm('你真的要取消这个订单吗?', '取消订单').then(() => {
                this.$bbs.post(this.baseCancelUrl, {order_id: order_id}, {
                    error: {
                        need: true,
                    }
                }).then(() => {
                    this.tableData.splice(index, 1);
                    this.page.total--;
                    this.$message.success('取消成功!');
                });
            });
        }
    }
}
</script>

<style lang="less" scoped>
.tmp_download-link {
    display: inline-block;
    padding: 0 6px;
    cursor: pointer;
    font-weight: 500;
    color: #409EFF;

    &:hover {
        text-decoration: underline;
    }
}

.auth-error {
    color: #ff7a7a;
}
</style>
